// Buscar clientes por nombre, cédula o teléfono.
//
// Estaba escrito tres veces —Pagos, Deuda y Clientes— y cada copia buscaba de
// una forma. Al añadir el buscador de Clientes ignorando tildes, quedó que
// escribir «ramirez» encontraba a RAMÍREZ en una pantalla y en las otras no.
// Que el mismo cliente aparezca o no según desde dónde lo busques es peor que
// no tener buscador.

// Sin tildes y en minúsculas. Nadie escribe «RAMÍREZ» con tilde al buscar, y
// los nombres se teclean como salen en la cédula.
export function normalizar(texto) {
  return (texto || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

// `tope` limita cuántos se devuelven, para las listas de sugerencias que se
// despliegan bajo un campo: veinte nombres tapando la pantalla no ayudan.
export function buscarClientes(clientes = [], texto = '', tope = 0) {
  const termino = normalizar(texto).trim();
  if (termino === '') return [];

  const hallados = clientes.filter(c =>
    normalizar(c.name).includes(termino) ||
    normalizar(c.cedula).includes(termino) ||
    normalizar(c.phone).includes(termino)
  );

  return tope > 0 ? hallados.slice(0, tope) : hallados;
}
